// eslint-disable-next-line import/no-named-as-default
import { Endpoint } from "@mongez/http";
import { getCurrentLocaleCode } from "@mongez/localization";
import { type GenericObject } from "@mongez/reinforcements";
import type { AxiosResponse } from "axios";
import { __DEV__ } from "./environment";

const clientId = "shipria-academy.com";
// const clientId = "elmohandes.academy";
// const clientId = "alhadaf-academy.com";
// const clientId = "almaher.academy";
// const clientId = "demo.me.mentoor.io";
// const clientId = "basembadr";
// const clientId = "ahmedelmasry";
// const clientId = "msusabry";
// const clientId = "seekerinmath";
// const clientId = "mohammed-alaa.com";
// const clientId = "raafat-rashdan";
// const clientId = "the-family";

const productionEndpointUrl = "https://api.feather.mentoor.io";
const endpointUrl = productionEndpointUrl;
// const endpointUrl = "http://localhost:2029";

export function getClientDomain(hostname?: string) {
  if (__DEV__) return clientId;
  if (!hostname) return "";
  return hostname.replace("www.", "");
}

export function endpoint(headers: GenericObject = {}) {
  const endpoint = new Endpoint({
    // baseURL: apiBaseUrl,
    baseURL: __DEV__ ? endpointUrl : productionEndpointUrl,
    headers: {
      "Content-Type": "application/json",
      "locale-code": getCurrentLocaleCode(),
      ...(__DEV__ ? { "client-id": clientId } : {}),
      ...headers,
    },
  });

  // Instance interceptor, NOT `endpoint.events.beforeSending`: see
  // `onEndpointResponse` below for why `endpoint.events.*` must not be used.
  endpoint.interceptors.request.use((config) => {
    if (config.method?.toLocaleLowerCase() === "post" && !config.data) {
      config.data = {};
    }

    return config;
  });

  return endpoint;
}

/**
 * Run `callback` with every response (success or error response) of `http`.
 *
 * Replaces `http.events.onComplete/onError/onSuccess/beforeSending`, which
 * must never be used on the server: @mongez/http registers those callbacks
 * in the process-global @mongez/events bus under a per-instance
 * `endpoint.<randomId>.*` key and nothing ever unsubscribes them. Because
 * `endpoint()` is created per SSR request, every request's Endpoint, Request,
 * cookies and user (captured by the callbacks) stayed reachable forever —
 * the mentor-me-app heap grew ~20 KB per request until V8 aborted with
 * "JavaScript heap out of memory". Axios instance interceptors live on the
 * instance itself and are garbage-collected with it.
 */
export function onEndpointResponse(
  http: Endpoint,
  callback: (response: AxiosResponse | undefined) => void,
) {
  http.interceptors.response.use(
    (response) => {
      callback(response);

      return response;
    },
    (error) => {
      callback(error?.response);

      return Promise.reject(error);
    },
  );
}
